export default __webpack_public_path__ + "static/media/image1.6e896f82.jpg";